module.exports = __webpack_public_path__ + "media/images/jiyuuni@2x-4d928f7e2d1d17bfa41c2091eebd2299.jpg";